import { bool, oneOf, shape } from 'prop-types';

export const backgroundVariantOptions = oneOf([
    '#FFFFFF',
    '#003057',
    '#F5FBFF',
    '#F9FBFF',
    'none'
]);
const cardBackgroundColorOptions = oneOf([
    'white',
    'grey',
    'everyday_gradient',
    'smart_gradient',
    'smart_plus_gradient'
]);

const hideByDeviceSize = {
    hideOnDesktop: bool,
    hideOnMobile: bool
};

const commonOptionsPropType = {
    commonOptions: shape({
        backgroundVariant: backgroundVariantOptions,
        cardBackground: cardBackgroundColorOptions,
        noUnderline: bool,
        listTickVariant: oneOf(['green', 'blue']),
        titleVariant: oneOf(['default', 'small', 'xs']),
        ...hideByDeviceSize
    })
};

export default commonOptionsPropType;
